import { LoyaltyEventCategory } from "Infrastructure/Api/Api";
import type { LoyaltyEventDto } from "Infrastructure/Api/Api";

export const eventFilters = {
  daily: (event: LoyaltyEventDto) =>
    event.frequency === LoyaltyEventCategory.Daily,
  weekly: (event: LoyaltyEventDto) =>
    event.frequency === LoyaltyEventCategory.Weekly,
  monthly: (event: LoyaltyEventDto) =>
    event.frequency === LoyaltyEventCategory.Monthly,
  longTerm: (event: LoyaltyEventDto) =>
    event.frequency === LoyaltyEventCategory.LongTerm,
  unlimited: (event: LoyaltyEventDto) =>
    event.frequency === LoyaltyEventCategory.Unlimited,
};

type TimeRemaining = {
  days: number;
  hours: number;
};

export const calculateTimeRemaining = (
  datetimeUTC: string | null | undefined,
): TimeRemaining => {
  if (!datetimeUTC) {
    return { days: 0, hours: 0 };
  }

  const resetDateUtc = new Date(datetimeUTC);
  const now = new Date();

  const diffMs = resetDateUtc.getTime() - now.getTime();

  if (diffMs <= 0) {
    return { days: 0, hours: 0 };
  }

  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const days = Math.floor(diffHours / 24);
  const hours = diffHours % 24;

  return { days, hours };
};
